import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * 获奖记录轮播组件
 */
import { isFunction } from '../../common/base';
import ams from '../../common/ams';
import loader from '../../common/loader';
import _Object from '../../common/object';
var defaultOption = {
  iAMSActivityId: -1,
  iFlowId: -1,
  activityId: -1,
  iNeedAreaRole: true,
  iNeedLogin: true
};

var getConfig = function getConfig(opt) {
  var iActivityId = opt.iActivityId,
      iFlowId = opt.iFlowId,
      flowConfig = opt.flowConfig;
  return ams.amsInit(iActivityId, iFlowId, flowConfig).then(function (_ref) {
    var config = _ref.config,
        flow = _ref.flow;
    // config = {
    //     iActivityId: '12345'
    // }
    console.log('test');

    var option = _objectSpread(_objectSpread(_objectSpread({}, defaultOption), config), {}, {
      iNeedAreaRole: flow.iNeedAreaRole !== 0,
      iNeedLogin: flow.iNeedLogin !== 0,
      activityId: flow.functions[0].sExtModuleId
    }); // const option = Object.assign({}, defaultOption, config, {
    // })


    return option;
  });
};

var filterData = function filterData(data, option) {
  var filterFunc = option.filter; // 过滤函数

  if (isFunction(filterFunc)) {
    // 整体过滤
    data = filterFunc(data) || [];
  }

  return data;
};

export default (function (opt) {
  return getConfig(opt).then(function (option) {
    var activityId = option.activityId,
        iFlowId = option.iFlowId,
        initDataUrl = option.initDataUrl,
        showDataConfine = option.showDataConfine;
    var url = "//gameact.qq.com/ams/lottery/v2.0/".concat(activityId % 100, "/").concat(activityId, "_broadcast.js");
    return loader.loadScript(url).then(function () {
      var lotteryList = window["Broadcast_".concat(activityId)] || [];
      lotteryList = _Object.decode(lotteryList);

      if (typeof initDataUrl === 'string' && initDataUrl) {
        return loader.loadScript("".concat(option.initDataUrl, ".js")).then(function () {
          var initData = window["Broadcast_InitData_".concat(iFlowId)];

          if (!Array.isArray(initData)) {
            alert('自定义初始数据格式不正确');
            return [];
          }

          if (showDataConfine && lotteryList.length < Number(showDataConfine)) {
            // 真实数据大于20时不显示初始数据(可选)
            lotteryList = initData.concat(lotteryList);
          }

          return filterData(lotteryList, option);
        });
      }

      return filterData(lotteryList, option);
    });
  });
});